export enum EAddressType {
  ZIPCODE = 'postal_code',
  STATE = 'administrative_area_level_1',
  CITY = 'locality',
  SUB_LOCALITY = 'sublocality',
  NEIGHBORHOOD = 'neighborhood',
  STREET = 'street_number',
  ROUTE = 'route',
}
